import addresses from 'config/constants/contracts'

const chainId = process.env.REACT_APP_CHAIN_ID

export const getCakeAddress = () => {
  return addresses.cake[chainId]
}

export const getBUSDAddress = () => {
  return addresses.busd[chainId]
}


export const getPREPRV2Address = () => {
  return addresses.prePrv2[chainId]
}

export const getPREPRVGAddress = () => {
  return addresses.prePrvg[chainId]
}

export const getPresaleAddress = (isBUSD) => {
  return isBUSD?addresses.busdPresale[chainId]:addresses.prvPresale[chainId]
}
export const getMasterChefAddress = () => {
  return addresses.masterChef[chainId]
}
export const getMulticallAddress = () => {
  return addresses.mulltiCall[chainId]
}
export const getWbnbAddress = () => {
  return addresses.wbnb[chainId]
}
export const getLotteryAddress = () => {
  return addresses.lottery[chainId]
}
export const getLotteryTicketAddress = () => {
  return addresses.lotteryNFT[chainId]
}

export const getForestAddress = () => {
  return addresses.forest[chainId]
}

export const getReferralAddress = () => {
  return addresses.referral[chainId]
}
